import HomeCarousel from "components/blocks/HomeCarousel";
import HomeDescription from "components/blocks/HomeDescription";
import HomeHero from "components/blocks/HomeHero";
import HomeInfographics from "components/blocks/HomeInfographics";
import HomeInfographics2023 from "components/blocks/HomeInfographics2023";
import PageFooter from "components/components/PageFooter";
import PageNavbar from "components/components/PageNavbar";
import RouterContext from "context/RouterContext";
import { useLayoutEffect, useEffect, useState } from "react";
import "swiper/css";
import "swiper/css/navigation";
import "./assets/reset.css";

const caseStudyMap = {
  cate: 0,
  kathy: 1,
  elliot: 2,
  kristie: 3,
  jo: 4,
  courtney: 5,
  wim: 6,
  cameron: 7,
  glen: 8,
  hayley: 9,
  nikki: 10,
};

function App() {
  const [caseStudy, setCaseStudy] = useState(0);

  useLayoutEffect(() => {
    const url = window.location.hash.substring(1); // remove the #

    if (caseStudyMap[url] !== undefined) {
      setCaseStudy(caseStudyMap[url]);
    }
  }, []);

  useEffect(() => {
    const element = document.getElementById("caseStudy");

    if (element) {
      const navbarHeight = document.getElementById("navbar").offsetHeight; // Adjust this based on your actual navbar ID
      const y = element.getBoundingClientRect().top + window.scrollY - navbarHeight;

      if (window.location.hash) {
        window.scrollTo({
          top: y,
          behavior: "smooth",
        });
      }
    }
  }, [caseStudy]);

  return (
    <>
      <RouterContext.Provider value={{ url: caseStudy }}>
        <PageNavbar />
        <HomeHero />
        <HomeDescription />
        <HomeInfographics2023 />
        <HomeCarousel caseStudy={caseStudy} />
        <PageFooter />
      </RouterContext.Provider>
    </>
  );
}

export default App;
